<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/P4qFxy/tc-custom/9781488060373.jpg?1726617311379" alt="This image is the cover for the book Seeking Refuge, Amish Seasons"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seeking Refuge, Amish Seasons
      </h1>
      <p class="bookDescription body article font2">
        <p>Will love be enough to heal their past?<br/><br/><b>Her secret kept them apart…<br/>Will courage give them another chance?<br/><br/></b>Days before her wedding, a wrenching ordeal shattered Josie Fisher’s dreams…and she fled to her Amish hometown to start over. Now Tobias Mast has arrived with two goals: to find Josie and learn why she called off their wedding, and to buy a home. When the only house he can afford is next door to Josie’s farm, will she finally risk telling him her dark secret?<br/><br/><b><i>USA TODAY</i></b><b> Bestselling Author</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lenora Worth
      </h2>
      
      <p class="authorDescription body article">Lenora Worth writes for&#160;Love Inspired and Love Inspired Suspense. She is a Carol Award finalist and&#160;a <I>New York Times</I>, <I>USA Today</I>, and <I>PW</I> bestselling author. She&#160;writes Southern stories set in places she loves such as Georgia, Texas, &#160;Louisiana, and Florida. Lenora is married and has two grown children and now lives near the ocean in the Panhandle of Florida. She loves reading, shoe shopping, long walks on the beach, mojitoes and road trips.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?709663b2